var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStraightRightArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9789_36904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0418 7.44484L11.0468 3.4695C10.5305 3.06938 9.75607 3.43078 9.75607 4.08903V5.41845C9.75607 5.84438 9.47212 6.21868 9.04619 6.21868H1.1084C0.682473 6.21868 0.333984 6.52845 0.333984 6.96729V9.05822C0.333984 9.47124 0.682473 9.83263 1.1084 9.83263H9.04619C9.47212 9.83263 9.75607 10.1683 9.75607 10.5941V11.9236C9.75607 12.5689 10.5305 12.9303 11.0339 12.5302L16.016 8.6581C16.429 8.36124 16.4419 7.75461 16.0418 7.44484Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9789_36904"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.333984)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStraightRightArrow);
export default __webpack_public_path__ + "static/media/straight_right_arrow.13d0ab61464c18f7856b331ce2e6c03b.svg";
export { ForwardRef as ReactComponent };